import { stripLegacyUrl } from "./routing/legacyUrl";

function getItemSpecificRAQ(baseRAQUrl: string, slug: string): string;
function getItemSpecificRAQ(
  baseRAQUrl: string | undefined,
  slug: string | undefined | null = undefined
): string | undefined {
  if (!baseRAQUrl) return undefined;
  const sUrlVersion = `${stripLegacyUrl(baseRAQUrl)}-s`;
  return [sUrlVersion, slug].filter((i) => !!i).join("/");
}

export function getCruiseSpecificRAQ(
  baseRAQUrl: string,
  cruiseCode: string
): string {
  return getItemSpecificRAQ(baseRAQUrl, `${cruiseCode.toUpperCase()}`);
}

export function getSuiteSpecificRAQ(
  baseRAQUrl: string | undefined,
  cruiseCode: string | undefined,
  shipId: string | undefined,
  suiteCode: string | undefined
): string | undefined {
  if (!baseRAQUrl || !cruiseCode || !shipId || !suiteCode) return undefined;

  const fullSlug = `${cruiseCode.toUpperCase()}/${suiteCode}`;
  return getItemSpecificRAQ(baseRAQUrl, fullSlug);
}
